import { commonConstants } from '../constants/common.constants';
// New version src/Common/browser/browser.service.ts CommonBrowser
// Old version src/CaseDotStar.ServicePackages.Frontend.Common/scripts/common/services/common_browser_service.js CommonBrowser

import * as _ from 'lodash';
import { Injectable } from '@angular/core';

export interface ICommonBrowserScrollSizes {
	width: number;
	height: number;
}

export interface ICommmonBrowserInfo {
	ie: boolean | null;
	unknown: boolean | null;
	chrome?: boolean | null;
	safari?: boolean | null;
	firefox?: boolean | null;
}

export interface ICommonBrowserDeviceData {
	device: {
		[key: string]: CallableFunction;
	};
	buildClasslist: () => string[];
}

const $html = $('html');
const userAgent = window.navigator.userAgent.toLowerCase();
const browsers = {
	ie: /Trident\/7/i,
	chrome: /chrome/i,
	safari: /safari/i,
	firefox: /firefox/i,
};

@Injectable()
export class CommonBrowser {
	browser: ICommmonBrowserInfo = {
		ie: null,
		unknown: null,
	};
	isHiddenTab: boolean;
	scrollSizes: ICommonBrowserScrollSizes;

	constructor () {
		this.detectBrowserData();
		this.addClassesToHtml();

		document.addEventListener('visibilitychange', () => {
			this.isHiddenTab = window.document.hidden;
		});
	}

	getIsAdaptiveScreen (): boolean {
		return window.matchMedia(`(max-width: ${commonConstants.adaptiveScreenWidth}px)`).matches;
	}

	getDeviceData (): ICommonBrowserDeviceData {
		const television = [
			'googletv',
			'viera',
			'smarttv',
			'internet.tv',
			'netcast',
			'nettv',
			'appletv',
			'boxee',
			'kylo',
			'roku',
			'dlnadoc',
			'pov_tv',
			'hbbtv',
			'ce-html',
		];
		const device = {
			macos : () => find('mac'),
			ios : () => device.iphone() || device.ipod() || device.ipad(),
			iphone : () => !device.windows() && find('iphone'),
			ipod : () => find('ipod'),
			ipad : () => find('ipad'),
			android () {
				return !this.windows() && find('android');
			},
			androidPhone () {
				return this.android() && find('mobile');
			},
			androidTablet () {
				return this.android() && !find('mobile');
			},
			blackberry : () => find('blackberry') || find('bb10') || find('rim'),
			blackberryPhone () {
				return this.blackberry() && !find('tablet');
			},
			blackberryTablet () {
				return this.blackberry() && find('tablet');
			},
			windows : () => find('windows'),
			windowsPhone () {
				return this.windows() && find('phone');
			},
			windowsTablet () {
				return this.windows() && (find('touch') && !this.windowsPhone());
			},
			fxos : () => (find('(mobile') || find('(tablet')) && find(' rv:'),
			fxosPhone () {
				return this.fxos() && find('mobile');
			},
			fxosTablet () {
				return this.fxos() && find('tablet');
			},
			meego : () => find('meego'),
			mobile () {
				return (
					this.androidPhone() ||
					this.iphone() ||
					this.ipod() ||
					this.windowsPhone() ||
					this.blackberryPhone() ||
					this.fxosPhone() ||
					this.meego()
				);
			},
			tablet () {
				return (
					this.ipad() ||
					this.androidTablet() ||
					this.blackberryTablet() ||
					this.windowsTablet() ||
					this.fxosTablet()
				);
			},
			desktop () {
				return !this.tablet() && !this.mobile();
			},
			touchscreenused () {
				// Fine-tune if needed (user may use touchscreen or mouse on the same device). Keep it simple for now
				return this.tablet() || this.mobile();
			},
			television () {
				let i = 0;
				while (i < television.length) {
					if (find(television[i])) {
						return true;
					}
					i++;
				}

				return false;
			},
		};

		const find  = (needle: string) => userAgent.indexOf(needle) !== -1;

		function buildClasslist (prefix = '') {
			const list = [];

			for (const p in device) {
				if (device[p]()) {
					list.push(prefix + p);
				}
			}

			return list;
		}

		return {
			device,
			buildClasslist,
		};
	}

	protected detectBrowserData (): void {
		_.each(browsers, (value, key) => {
			this.browser[key] = browsers[key].test(userAgent);

			if (this.browser[key]) {
				$html.addClass(key);
			}
		});

		this.browser.unknown = !_.keys(this.browser).length;
		this.scrollSizes = this.getScrollSizes();
		this.isHiddenTab = window.document.hidden;
	}

	protected addClassesToHtml (): void {
		const deviceData = this.getDeviceData();

		deviceData.buildClasslist().forEach((deviceClass) => {
			$html.addClass(deviceClass);
		});

		_.each(browsers, (value, key) => {
			if (this.browser[key]) {
				$html.addClass(key);
			}
		});
	}

	protected getScrollSizes (): ICommonBrowserScrollSizes {
		const size = 100;
		const child = $('<div/>')
			.css({
				height: '100%',
			});

		const tester = $('<div class="b-tester-scroll_size"></div>')
			.css({
				position: 'absolute',
				top: '-9999px',
				left: '-9999px',
				overflow: 'scroll',
				height: size + 'px',
				width: size + 'px',
			});

		child.appendTo(tester);
		tester.appendTo('body');

		const result = {
			width: size - child.width()!,
			height: size - child.height()!,
		};

		tester.remove();
		return result;
	}
}

export const commonBrowserService = new CommonBrowser();
